import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { useTenantContext } from "../../tenant/TenantContext";

// Mismo rojo que el resto de avisos de stock de la web (el danger de Bootstrap)
const PILL_BASE = {
    color: "#fff",
    fontSize: "0.8rem",
    lineHeight: 1.4
};

/**
 * Aviso para productos bajo pedido con bypass de stock (details.stockBypass):
 * se pueden pedir aunque no haya unidades y la fecha estimada de entrega se
 * consulta por teléfono. El teléfono sale de la config del tenant (cada marca
 * enseña el suyo).
 *
 * variant="info" (por defecto): caja azul de aviso (modal de compra rápida).
 * variant="pill": pastilla para la ficha (bajo el precio) y la línea del carrito.
 * pillColor: "red" (carrito) o "primary" (ficha: el azul del tenant; en rojo quedaba raro).
 * message: texto alternativo (el texto de stock del producto que viene de BC, ej. "Disponible
 * en 10 días bajo pedido."); si no llega, se usa el genérico con el teléfono del tenant.
 * requestedQuantity: unidades pedidas (la línea del carrito). Si se piden más de las que hay
 * y HAY stock parcial, el aviso pasa a explicar el envío en dos tandas: las que hay llegan en
 * el plazo habitual y el resto más adelante (el bypass mete la línea entera sin split).
 */
export const StockBypassNotice = ({ product, className = "", variant = "info", pillColor = "red", message = null, requestedQuantity = null }) => {
    const { tel, primaryColor } = useTenantContext();
    if (!product?.stockBypass) {
        return null;
    }
    const stock = product.stock ?? 0;
    const laterUnits = requestedQuantity != null && stock > 0 && requestedQuantity > stock
        ? requestedQuantity - stock
        : 0;
    const phoneLink = (
        <>llámanos{tel ? <> al <a href={`tel:${tel}`} className={`fw-bold text-nowrap ${variant === "pill" ? "text-white" : ""}`}>{tel}</a></> : null}.</>
    );
    let content;
    if (laterUnits > 0) {
        content = (
            <span>
                Bajo pedido: te {stock === 1 ? "llega 1 ud." : `llegan ${stock} uds.`} en el plazo
                habitual y {laterUnits === 1 ? "la otra" : `las otras ${laterUnits}`} más tarde.
                Fecha estimada: {phoneLink}
            </span>
        );
    } else if (message) {
        content = <span>{message}</span>;
    } else {
        content = (
            <span>
                Producto bajo pedido: puedes pedirlo aunque no haya stock. Si quieres saber la fecha
                estimada de entrega, {phoneLink}
            </span>
        );
    }
    const showPhoneIcon = laterUnits > 0 || !message;
    if (variant === "pill") {
        const pillStyle = {
            ...PILL_BASE,
            backgroundColor: pillColor === "primary" ? (primaryColor || "#0dcaf0") : "#dc3545",
            // La de la ficha (azul) con letra mayor a petición del jefe; la del carrito se queda pequeña
            ...(pillColor === "primary" && { fontSize: "0.95rem" })
        };
        return (
            <span className={`badge rounded-pill text-wrap text-start fw-normal d-inline-flex align-items-center gap-2 py-2 px-3 ${className}`}
                  style={pillStyle}
                  role="status">
                {showPhoneIcon && <PhoneInTalkIcon fontSize="small" />}
                {content}
            </span>
        );
    }
    return (
        <div className={`alert alert-info d-flex align-items-center gap-2 py-2 ${className}`} role="status">
            {showPhoneIcon && <PhoneInTalkIcon fontSize="small" />}
            {content}
        </div>
    );
};
